import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import { actions as ConnectionActions } from '../../../Ducks/Connection.duck';
import ValidationRunsTable from '../../../Components/ValidationRunsTable';
import { useBreadcrumb } from 'app/components/Breadcrumbs';

const ValidationRunsTab = () => {
  const dispatch = useDispatch();
  const { connectionId } = useParams();

  const { validationRuns } = useSelector(state => state.ConnectionReducer);
  const { loading: connectionLoading } = useSelector(state => state.ConnectionReducer);

  useEffect(() => {
    dispatch(ConnectionActions.requestData(connectionId));
    dispatch(ConnectionActions.validationRuns.requestData({ connectionId }));
  }, [connectionId, dispatch]);

  useBreadcrumb('connections.tab.validationRuns');

  return (
    <Grid container spacing={5}>
      <Grid item xs={12}>
        <ValidationRunsTable
          validationRuns={validationRuns?.items || []}
          loading={validationRuns?.loading || connectionLoading}
        />
      </Grid>
    </Grid>
  );
};

export default ValidationRunsTab;
